import { render, staticRenderFns } from "./TermsContentInternal.vue?vue&type=template&id=f4cb29ce&scoped=true"
import script from "./TermsContentInternal.vue?vue&type=script&lang=js"
export * from "./TermsContentInternal.vue?vue&type=script&lang=js"
import style0 from "./TermsContentInternal.vue?vue&type=style&index=0&id=f4cb29ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4cb29ce",
  null
  
)

export default component.exports